import React from "react";
import { Box, Container, Typography, Paper } from "@mui/material";
 
const cases = [
  {
    tag: "化学・製造業",
    title: "社内従業員ポータルサイト",
    description:
      "お知らせ、カレンダー、タスク管理、サポートチケット、よく使うリンクを1つの画面にまとめた全社ポータルです。誕生日のリマインダーや新入社員の紹介ページも用意し、業務連絡だけの場所にならないようにしました。タスクや案件の進捗はチャートで表示され、部門ごとの状況が一目で分かります。",
  },
  {
    tag: "商社",
    title: "情報共有・業務支援ポータルサイト",
    description:
      "扱う情報量が多いため、ニュースにタグを付けて整理し、「人気タグ」から関連情報をたどれるようにしています。\nお知らせはカード形式で一覧表示し、サイト内検索と地図・画像による表示を組み合わせることで、目的の情報に行き着くまでの手間を減らしました。",
  },
  {
    tag: "飲食製造業",
    title: "情報共有ポータルサイト",
    description:
      "ニュース表示、よく使うリンク、タスク管理に加えて、Word・Excel・PowerPointのファイルをブラウザ上でそのまま開けるドキュメントライブラリを設けました。\n従業員紹介と写真ギャラリーもあり、工場と本社に人が分かれていても顔と名前が分かる状態を保てます。",
  },
  {
    tag: "金融業",
    title: "資料共有・承認ワークフローポータル",
    description:
      "トップ画面のダッシュボードで、登録資産数と「承認済み・期限間近・期限切れ」の件数を確認できます。承認者には専用の承認画面を用意し、検索結果も本人が閲覧できる資料だけに絞られます。\nバージョン履歴が残るため、いつ誰が何を差し替えたかを後から追えます。",
  },
  {
    tag: "企業横断",
    title: "社内アンケート＆自動集計レポート",
    description:
      "アンケートの配信から回収、集計、レポート出力までをSharePoint上で完結させました。回答は入力と同時に集計され、部門別・拠点別のクロス集計もその場で確認できます。回答率が画面に出るので、未回答の部署だけに声をかければよく、Excelへの転記と催促メールのやり取りがなくなりました。",
  },
  {
    tag: "企業横断",
    title: "内部統制監査ツール＆監査レポート",
    description:
      "J-SOX対応などのチェックリストと証跡となる書類の収集・保管を1か所にまとめました。項目ごとの状況（未実施・実施中・完了・要是正）が一覧で分かるため、期末前に何が残っているかを追いかけやすくなります。監査結果は決まった書式のレポートとして出力でき、バージョン履歴とAzure AD（Entra ID）の権限設定が証跡として残ります。",
  },
];
 
const CaseStudies = () => {
  return (
    <Box sx={{ backgroundColor: "#F4F5F6", py: { xs: 6, md: 8 } }}>
      <Container maxWidth={false} sx={{ width: "92%", mx: "auto" }}>
        <Typography
          sx={{
            color: "#FF6000",
            fontWeight: 700,
            fontSize: "13px",
            letterSpacing: "1px",
            mb: 1,
          }}
        >
          CASE STUDIES
        </Typography>
 
        <Typography
          sx={{ fontWeight: 700, fontSize: { xs: "26px", md: "50px" }, mb: 1.5 }}
        >
          導入事例・ユースケース
        </Typography>
 
        <Typography
          sx={{
            fontSize: "20px",
            color: "rgba(0,0,0,0.65)",
            mb: { xs: 4, md: 5 },
          }}
        >
          化学製造・商社・飲食製造・金融など、業種ごとの業務要件に合わせた構築実績があります
        </Typography>
 
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
            },
            gap: 3,
          }}
        >
          {cases.map((item) => (
            <Paper
              key={item.title}
              elevation={0}
              sx={{
                borderRadius: "12px",
                border: "1px solid rgba(0,0,0,0.08)",
                backgroundColor: "#fff",
                p: 2.5,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography
                sx={{
                  color: "#FF6000",
                  fontWeight: 700,
                  fontSize: "13px",
                  mb: 1,
                }}
              >
                {item.tag}
              </Typography>
 
              <Typography sx={{ fontWeight: 700, fontSize: "17px", mb: 1.5 }}>
                {item.title}
              </Typography>
 
              <Typography
                sx={{
                  fontSize: "13px",
                  lineHeight: 1.8,
                  color: "rgba(0,0,0,0.7)",
                  mb: 2.5,
                  whiteSpace: { xs: "normal", sm: "pre-line" },
                }}
              >
                {item.description}
              </Typography>
 
              <Box
                sx={{
                  mt: "auto",
                  height: 110,
                  backgroundColor: "#f0f0f1",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography sx={{ fontSize: "13px", color: "rgba(0,0,0,0.55)" }}>
                  ポータル画面
                </Typography>
              </Box>
            </Paper>
          ))}
        </Box>
 
        <Paper
          elevation={0}
          sx={{
            mt: 4,
            p: 3,
            borderRadius: "12px",
            // border: "1px solid rgba(0,0,0,0.08)",
            backgroundColor: "#D9D9D9",
          }}
        >
          <Typography sx={{ fontSize: "20px", color: "#000" }}>
            【その他のユースケース】
          </Typography>
          <Typography sx={{ fontSize: "20px", lineHeight: 2, color: "#000" }}>
            ・店舗・拠点向け 社内調査サイト（多拠点からのチェックリスト回答と、本部でのリアルタイムモニタリング）
            <br />
            ・全社お知らせ・掲示板サイト（重要告知、カテゴリ別ニュース配信、人気タグによる情報検索）
            <br />
            ・外部リンク・クイックアクセス集約サイト（社内外の主要システムへのSSO対応リンク集）
            <br />
            ・カレンダー・スケジュール管理サイト（社内イベント・タスク期限・会議予定を全社／チーム単位で一元共有）
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};
 
export default CaseStudies;